import FAQListItem from './FAQListItem'
export default FAQListItem